import * as React from 'react';
import { IStylingUser } from '../Entities';
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import FormSelect from '../../../components/common/FormSelect';
import { Translate } from '../../../shared/LanguageService';
import FormValidationService from '../../../shared/form/FormValidationService';
import { IStylingFirm } from '../../stylingfirms/Entities';
import RoleSelect from './RoleSelect';
import FieldInfoIcon from '../../../components/common/FieldInfoIcon';
import CountryCodePhoneNumberInput from '../../../components/common/CountryCodePhoneNumberInput';
import LanguageSelect from '../../../components/common/LanguageSelect';

interface IStylingUsersFormProps {
    input: IStylingUser;
    stylingfirms: IStylingFirm[];
    availableRoles: any[];
    availableLanguages: any[];
    onChange: (value: any) => void;
    errors: any;
    user: any;
}

const StylingUserForm = (props: IStylingUsersFormProps) => {
    const { apiUrl } = window.appConfig;

    const showStylingFirmChoice = !(props.user.details.role === 'role/styling-admin' && props.stylingfirms.length === 1)

    return (
        <Row>
            <Col md={props.input.profileImageReference ? 8 : 12}>
                {showStylingFirmChoice && (
                  <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(
                        props.errors.stylingFirmId
                    )}
                  >
                    <ControlLabel>
                        {Translate('styling-user/form/styling-firm-select-label')}
                    </ControlLabel>
                    <FormSelect
                        name="stylingFirmId"
                        autoFocus
                        onChange={props.onChange}
                        value={props.input.stylingFirmId as any}
                        defaultTranslateKey="styling-user/form/styling-firm-select/items/instructions"
                        disabled = {props.stylingfirms.length === 1}
                    >
                        {props.stylingfirms.map((t: any) => {
                            return (
                                <option key={t.id} value={t.id}>
                                    {t.name}
                                </option>
                            );
                        })}
                    </FormSelect>
                    <HelpBlock>{props.errors.stylingFirmId}</HelpBlock>
                  </FormGroup>
                )}

                <RoleSelect
                    onChange={props.onChange}
                    roles={props.availableRoles}
                    role={props.input.roleId}
                    error={props.errors.role}
                />

                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(props.errors.name)}
                >
                    <ControlLabel>{Translate('styling-user/form/name-label')}</ControlLabel>
                    <FormControl
                        type="text"
                        name="name"
                        value={props.input.name ? props.input.name : ''}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.name}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(
                        props.errors.username
                    )}
                >
                    <ControlLabel>{Translate('styling-user/form/username-label')}</ControlLabel>
                    <FormControl
                        type="text"
                        name="username"
                        value={props.input.username ? props.input.username : ''}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.username}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(props.errors.email)}
                >
                    <ControlLabel>
                        {Translate('styling-user/form/email-address-label')}
                    </ControlLabel>
                    <FormControl
                        type="email"
                        name="email"
                        value={props.input.email ? props.input.email : props.input.username}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.email}</HelpBlock>
                </FormGroup>
                <FormGroup
                    validationState={FormValidationService.getValidationState(
                        props.errors.phoneNumber
                    )}
                >
                    <ControlLabel>{Translate('styling-user/form/phone-number-label')}</ControlLabel>
                    <FieldInfoIcon
                        title={Translate('popover/info/title/phonenumber')}
                        content={Translate('popover/info/content/phonenumber')}
                    />
                    <CountryCodePhoneNumberInput
                        value={props.input.phoneNumber}
                        onChange={(val) =>
                            props.onChange({
                                target: { name: 'phoneNumber', value: val }
                            })
                        }
                    />
                    <HelpBlock>{props.errors.phoneNumber}</HelpBlock>
                </FormGroup>
                <LanguageSelect
                    onChange={props.onChange}
                    languageKey={props.input.languageKey}
                    errors={props.errors}
                    languages={props.availableLanguages}
                />
            </Col>
            {props.input.profileImageReference && (
                <Col className="profile-image-preview" md={3}>
                    <img src={`${apiUrl}/file/${props.input.profileImageReference}`} />
                </Col>
            )}
        </Row>
    );
};

export default StylingUserForm;
